<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="15" viewBox="0 0 11 15">
    <path :fill="color" fill-rule="evenodd" d="M10.622 9.922l-4.216 4.102c-.233.246-.55.369-.899.369-.35 0-.662-.123-.9-.369L.378 9.922a1.225 1.225 0 0 1 0-1.767 1.31 1.31 0 0 1 1.814 0l2.023 1.972V1.252C4.214.56 4.788 0 5.5 0c.71 0 1.285.56 1.285 1.252v8.875l2.023-1.972a1.31 1.31 0 0 1 1.815 0 1.225 1.225 0 0 1 0 1.767z"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#6C9F0F'
    }
  }
}
</script>